// extracted by mini-css-extract-plugin
module.exports = {"faqs":"SupplierFAQs_faqs__bBfmK","faq":"SupplierFAQs_faq__H7WRV","active":"SupplierFAQs_active__olwLk"};